import {
  type RoleRequirementsEvent,
  UnifiedAnalyticsEvent,
  type UnifiedPayload,
} from '../types';

import { spreadableTestingId } from './experiments';

interface UnifiedCPQAQuestionsDisplayedPayload
  extends UnifiedPayload<UnifiedAnalyticsEvent.CPQAQuestionsDisplayed> {}

const sendCPQAQuestionsDisplayedEvent =
  (onEvent: (event: RoleRequirementsEvent) => void) => (): void => {
    onEvent({
      data: [
        {
          payload: {
            analytics: {
              eventName: UnifiedAnalyticsEvent.CPQAQuestionsDisplayed,
              currentPageSection: 'role requirements',
              ...spreadableTestingId(),
            },
          },
        },
      ],
    });
  };

export {
  type UnifiedCPQAQuestionsDisplayedPayload,
  sendCPQAQuestionsDisplayedEvent,
};
